import { Injectable } from '@angular/core';
import {ExtendedHttpResponse, HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {Observable} from "rxjs";

@Injectable()
export class TherapyMatchService {
  private baseUrl = '/therapyMatch';

  constructor(
    private _http: HttpInterceptorService
  ) {
  }

  public getAll(revisionId: string): Observable<ExtendedHttpResponse<any>> {
    return this._http.get(this.baseUrl, { context : revisionId });
  }
}
